import React, { useState, useEffect, useCallback } from 'react';
import './CarbonCalculator.css';

const carData = [
  { name: 'Ford F-150 2024 (3.5L V6 EcoBoost)', mpg: 20 },
  { name: 'Chevrolet Silverado 1500 2024 (5.3L V8)', mpg: 17 },
  { name: 'Toyota RAV4 2024 (2.5L I4 Hybrid)', mpg: 40 },
  { name: 'Honda CR-V 2024 (1.5L Turbocharged I4)', mpg: 30 },
  { name: 'Toyota Camry 2024 (2.5L I4 Hybrid)', mpg: 52 },
  { name: 'Toyota Prius 2024 (2.0L I4 Hybrid)', mpg: 57 },
  { name: 'Nissan Rogue 2024 (1.5L Turbocharged I3)', mpg: 33 },
  { name: 'Hyundai Tucson 2024 (2.5L I4 Gasoline)', mpg: 28 },
  { name: 'Subaru Outback 2024 (2.5L Boxer I4 AWD)', mpg: 28 },
];

const CarbonCalculator = () => {
  const [distance, setDistance] = useState('1000');
  const [mpg, setMpg] = useState('25');
  const [fuelType, setFuelType] = useState('gasoline');
  const [co2Emission, setCo2Emission] = useState(null);
  const [treesNeeded, setTreesNeeded] = useState(null);
  const [selectedCar, setSelectedCar] = useState('');

  const calculateEmissions = useCallback(() => {
    const fuelEmissionFactors = {
      gasoline: 8.887, // kg CO2 per gallon
      diesel: 10.180
    };

    const annualDistance = parseFloat(distance) * 12;
    const fuelUsed = annualDistance / parseFloat(mpg);
    const emissionFactor = fuelEmissionFactors[fuelType];
    const annualEmissions = fuelUsed * emissionFactor;
    setCo2Emission(annualEmissions.toFixed(2));
    const trees = (annualEmissions / 21.77).toFixed(2);
    setTreesNeeded(trees);
  }, [distance, mpg, fuelType]);

  useEffect(() => {
    calculateEmissions();
  }, [calculateEmissions]);

  const handleCarChange = (e) => {
    const selectedCarName = e.target.value;
    setSelectedCar(selectedCarName);
    const car = carData.find(car => car.name === selectedCarName);
    if (car) {
      setMpg(car.mpg.toString());
    }
  };

  useEffect(() => {
    if (selectedCar) {
      calculateEmissions();
    }
  }, [selectedCar, calculateEmissions]);

  return (
    <div className="carbon-calculator-container">
      <h1>Carbon Calculator</h1>
      <div className="input-group">
        <label htmlFor="distance">Monthly Distance (miles):</label>
        <input
          type="number"
          id="distance"
          value={distance}
          onChange={(e) => setDistance(e.target.value)}
        />
      </div>
      <div className="input-group">
        <label htmlFor="mpg">Average MPG:</label>
        <input
          type="number"
          id="mpg"
          value={mpg}
          onChange={(e) => setMpg(e.target.value)}
        />
      </div>
      <div className="input-group">
        <label htmlFor="car">Select a Car (optional):</label>
        <select id="car" value={selectedCar} onChange={handleCarChange}>
          <option value="">Choose a car (optional)</option>
          {carData.map((car) => (
            <option key={car.name} value={car.name}>
              {car.name}
            </option>
          ))}
        </select>
      </div>
      <div className="fuel-type-tabs">
        <button
          className={`fuel-tab ${fuelType === 'gasoline' ? 'active' : ''}`}
          onClick={() => setFuelType('gasoline')}
        >
          Gasoline
        </button>
        <button
          className={`fuel-tab ${fuelType === 'diesel' ? 'active' : ''}`}
          onClick={() => setFuelType('diesel')}
        >
          Diesel
        </button>
      </div>
      <button className="calculate-button" onClick={calculateEmissions}>
        Calculate
      </button>
      {co2Emission !== null && (
        <div className="result">
          <h2>Annual CO2 Emissions</h2>
          <p>{co2Emission} kg CO2</p>
          <h2>Trees Needed to Offset</h2>
          <p>{treesNeeded} trees</p>
        </div>
      )}
    </div>
  );
};

export default CarbonCalculator;